"use client";

import { m, useInView } from "framer-motion";
import { useRef } from "react";
import AutoContactLine from "../autoContactLine";

interface ContactBlock {
  label: string;
  lines: string[];
}

interface Props {
  data?: {
    blocks: ContactBlock[];
  };
}

const itemVariants = {
  initial: { opacity: 0, y: 32 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      type: "spring",
    },
  },
};

export default function ContactInfoSection({ data }: Props) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <m.section
      ref={ref}
      className="bg-neutral-900 text-white section"
      transition={{ staggerChildren: 0.1, delayChildren: 0.2 }}
      initial="initial"
      animate={isInView ? "animate" : "initial"}
    >
      <div className="container mx-auto flex flex-col items-center gap-12 px-4">
        {data?.blocks?.map((block, i) => (
          <m.div key={i} variants={itemVariants} className="flex flex-col items-center gap-3 text-center">
            <span className="font-mono text-sm uppercase tracking-wider opacity-60">{block.label}</span>
            {block.lines.map((line, j) => (
              <AutoContactLine key={j} line={line} className="text-sm leading-relaxed" />
            ))}
          </m.div>
        ))}
      </div>
    </m.section>
  );
}
